import idlImport from './CanCan.did.js';
export const idlFactory = idlImport;
export const canisterId = "r3ysn-mqaaa-aaaah-qabra-cai";
